export const MILLISECOND_TO_SECOND = 1000

export const SECONDS_TO_MINUTES = 60

export const CHARACTERS = 2
